module.exports = __webpack_public_path__ + "media/images/front/icons/info-cbfa5982fa0cb0c95967bf7958212249.png";